<template>
    <div class="h-screen overflow-y-auto bg-white">
        <modal name="modal-view-piece" height="auto" :scrollable="true" :adaptive="true">
            <div style="z-index: 999 !important;">
                <div class="p-4">
                    <div class="flex items-center justify-between mb-4">
                        <div></div>
                        <button @click="$modal.hide('modal-view-piece')" class="bg-red-500 text-white px-2 rounded">
                            <i class="fas fa-times text-xl"></i>
                        </button>
                    </div>
                    <div style="max-height: 80vh; overflow-y: auto;">
                        <div v-if="selectedPiece" class="pb-5">
                            <div v-html="selectedPiece.content"></div>
                        </div>
                    </div>
                </div>
            </div>
        </modal>


        <modal name="modal-claim-visite" height="auto" :scrollable="true" :adaptive="true">
            <div class="p-4" style="z-index: 999 !important;">
                <div class="flex items-center justify-end mb-2">
                    <button @click="$modal.hide('modal-claim-visite')" class="bg-red-500 text-white px-2 rounded">
                            <i class="fas fa-times text-xl"></i>
                        </button>
                </div>
                <div>
                <div class="px-6 pb-6 w-full">
                    <h2 class="text-2xl font-bold mb-4 text-gray-800">Prendre Rendez-vous</h2>
                    <form action="#" method="POST" class="space-y-4">
                        <!-- Nom complet -->
                        <div>
                            <label for="full_name" class="block text-sm font-medium text-gray-700">Nom complet</label>
                            <input 
                                type="text" 
                                id="full_name" 
                                name="full_name" 
                                required 
                                class="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                        </div>

                        <!-- Email -->
                        <div>
                            <label for="email" class="block text-sm font-medium text-gray-700">Adresse email</label>
                            <input 
                                type="email" 
                                id="email" 
                                name="email" 
                                required 
                                class="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                        </div>

                        <!-- Numéro de téléphone -->
                        <div>
                            <label for="phone" class="block text-sm font-medium text-gray-700">Numéro de téléphone</label>
                            <input 
                                type="tel" 
                                id="phone" 
                                name="phone" 
                                required 
                                class="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                        </div>

                        <!-- Date et heure de la visite -->
                        <div>
                            <label for="visit_date" class="block text-sm font-medium text-gray-700">Date et heure de la visite</label>
                            <input 
                                type="datetime-local" 
                                id="visit_date" 
                                name="visit_date" 
                                required 
                                class="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                        </div>

                        <!-- Message optionnel -->
                        <div>
                            <label for="message" class="block text-sm font-medium text-gray-700">Message (optionnel)</label>
                            <textarea 
                                id="message" 
                                name="message" 
                                rows="4" 
                                class="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"></textarea>
                        </div>

                        <!-- Bouton de soumission -->
                        <div>
                            <button 
                                @click="$toast.warning('RDV impossible: Espace de démonstration')"
                                type="submit" 
                                class="w-full bg-orange-600 text-white px-4 py-2 rounded-md shadow-sm hover:bg-orange-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2">
                                Prendre rendez-vous
                            </button>
                        </div>
                    </form>
                </div>
                </div>
            </div>
        </modal>

        <div v-if="false">
            <h1>Convertir un plan en SVG (sans textes)</h1>
            <input type="file" @change="handleFileUpload" />
            <div v-html="svgOutput" style="border: 1px solid #ddd; margin-top: 20px;"></div>
        </div>
        <div class="container mx-auto p-4">
            <div class="py-6">
                <div class="md:flex justify-between items-center">
                    <div class="flex justify-center md:justify-start items-center gap-2 mb-8 md:mb-0">
                        <img class="h-[40px]" src="https://i.ibb.co/L5PGw4d/Nouveau-projet-80-1.png" alt="">
                        <div>
                            <div class="text-xl font-bold text-orange-600">Agence Immovation</div>
                            <div class="font-light text-sm">Votre bien à portée de main</div>
                        </div>
                    </div>
                    <div class="flex justify-center md:justify-start items-center gap-1">
                        <div @click="$modal.show('modal-claim-visite')" class="bg-slate-100 hover:bg-slate-200 duration-200 cursor-pointer rounded px-4 py-2 text-sm">Demander une visite</div>
                        <a href="https://ultra.realhomes.io/" target="_blank" class="bg-orange-600 hover:bg-orange-700 duration-200 cursor-pointer text-white rounded px-4 py-2 text-sm">Consulter notre site</a>
                    </div>
                </div>
            </div>
            <div>
                <div class="md:px-10 mt-4 md:mt-[10vh]">
                    <!-- https://i.ibb.co/KKsjcYF/Capture-d-e-cran-2024-12-13-a-12-34-41.png -->
                    <h1 class="font-bold text-2xl text-center">Cliquez sur une pièce pour la découvrir</h1>
                    <h2 class="mt-1 mb-4 font-thin text-sm text-center">En cliquant sur un point clignotant ci-dessous, vous pouvez visualiser une pièce</h2>
                    <div class="relative md:max-w-[700px] mx-auto">
                        <img class="w-full opacity-60" src="https://i.ibb.co/cgqPyvn/Capture-d-e-cran-2024-12-13-a-11-57-09-1.png" alt="">
                        <div v-for="(piece, pieceIndex) in pieces" :key="'piece-marker-' + pieceIndex" @click="viewPiece(piece)" class="z-2 text-white cursor-pointer absolute flex items-center rounded-full" :class="'top-[' + piece.position_y + '%] left-[' + piece.position_x + '%]' + ' ' + (piecesViewed.find((item) => item == piece.id) ? 'bg-gray-600 hover:bg-gray-700' : 'bg-orange-500 hover:bg-orange-600')">
                            <span class="w-[28px] h-[28px] loader"></span>
                        </div>
                    </div>
                </div>
                <div class="text-2xl font-light text-slate-800 text-center mt-14">
                    <i class="fas fa-arrow-down mr-6"></i> En savoir plus
                </div>
                <!-- Description -->
                <section class="section mt-4 text-xl font-thin text-center max-w-[1000px] mx-auto">
                    <p>Situé dans un quartier calme, cette appartement de 3 pièces offre un cadre idéal pour un couple ou une famille. Proche des écoles et commerces, avec un grand balcon et garage.</p>
                </section>

                <!-- Détails du bien -->
                <div class="mt-10 max-w-[1000px] mx-auto">
                    <section class="section mt-4 border shadow p-4 rounded-xl">
                        <h2 class="text-lg mb-4 font-bold border-b pb-4 text-orange-600"><i class="fa-solid fa-list mr-2"></i> Détails du Bien</h2>
                        <div class="font-light md:grid grid-cols-3 space-y-4 gap-4 items-end mb-4">
                            <div>Surface habitable : 74,07 m²</div>
                            <div>Surface balcon : 15,29 m²</div>
                            <div>Nombre de pièces : 3</div>
                            <div>Nombre de chambres : 2</div>
                            <div>Nombre de salles de bain : 1</div>
                            <div>Nombre de WC : 1</div>
                            <div>Année de construction : 2008</div>
                            <div>État général : Bon état</div>
                            <div>Chauffage : Gaz</div>
                            <div>Meublé : Non</div>
                            <div>Stationnement : Garage (1 place)</div>
                            <div>Etage : 1</div>
                        </div>
                    </section>

                    <!-- Localisation -->
                    <div class="md:grid grid-cols-2 gap-4">
                        <section class="section mt-4 border shadow p-4 rounded-xl">
                            <h2 class="text-lg mb-4 font-bold border-b pb-4 text-orange-600"><i class="fas fa-location-dot mr-2"></i> Localisation</h2>
                            <ul class="space-y-4">
                                <li>Adresse : <a target="_blank" class="text-orange-500 underline font-light" href="https://www.google.fr/maps/place/10+Rue+des+Marronniers,+69002+Lyon/@45.7567545,4.8296974,1611m/data=!3m2!1e3!4b1!4m6!3m5!1s0x47f4ea5177f8bb9b:0xfa6ac6f66c1d866b!8m2!3d45.7567546!4d4.8345683!16s%2Fg%2F11csm_tl1v?entry=ttu&g_ep=EgoyMDI0MTIxMS4wIKXMDSoASAFQAw%3D%3D">1O rue des Marroniers, 69002 Lyon, France</a></li>
                                <li>Transports : Bus à 200m, Métro ligne D à 1km</li>
                                <li>Commerces : Supermarché à 500m</li>
                                <li>Écoles : École primaire et collège à 800m</li>
                            </ul>
                            <div class="mb-4"></div>
                        </section>
    
                        <!-- Informations légales -->
                        <section class="section mt-4 border shadow p-4 rounded-xl">
                            <h2 class="text-lg mb-4 font-bold border-b pb-4 text-orange-600"><i class="fa-solid fa-gavel mr-2"></i> Informations Légales</h2>
                            <ul class="space-y-4 mb-4">
                                <li>Classe énergie : C (110 kWhEP/m².an)</li>
                                <li>Classe GES : A (5 kgéqCO2/m².an)</li>
                                <li>Diagnostics : Amiante (Absence), Plomb (Absence)</li>
                            </ul>
                        </section>
                    </div>

                    <!-- Détails sur le vendeur -->
                    <section class="section mt-4 border shadow p-4 rounded-xl">
                        <h2 class="text-lg mb-4 font-bold border-b pb-4 text-orange-600"><i class="fa-solid fa-comments mr-2"></i>  Contact</h2>
                        <div class="space-y-4">
                            <p class="font-bold text-xl mb-2">Agence Immovation</p>
                            <div>Téléphone : 04 78 01 23 45</div>
                            <div>Email : contact@immovation.fr</div>
                            <div class="mb-4">Site web : http://immovation.com/</div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
        <div class="border flex flex-col col-span-2 h-[400px] fixed bottom-10 right-10 bg-white shadow w-[300px] rounded-xl" v-if="false">
            <div class="p-2 mt-2">
                <h2 class="font-bold">Assistant immobilier</h2>
            </div>
            <div class="p-2 mb-2 grow">
                <div class="bg-orange-100 p-4 rounded text-sm w-[70%]">
                    Bonjour,<br />
                    Je suis un assistant immobilier AI, vous pouvez me poser des questions concernant l'annonce, le bien, l'agencement des pièces, etc..
                </div>
            </div>
            <textarea class="border-t p-1.5 font-light focus:outline-none rounded-b-xl" placeholder="Votre message.."></textarea>
        </div>

        <div class="py-2 text-center mb-20">
            <div>Etape suivante</div>
            <div class="mt-2"><i class="fas fa-arrow-down"></i></div>
        </div>
        <div class="fixed bottom-0 left-0 right-0 py-5 bg-white/50 backdrop-blur-lg px-2">
            <div class="md:w-[900px] mx-auto flex justify-center gap-4">
                <button @click="$router.push({name: 'home'})" class="bg-slate-200 hover:bg-slate-300 duration-200 md:text-lg px-8 py-2 rounded-full">
                    <i class="fas fa-chevron-left mr-2"></i> Retour
                </button>
                <button @click="$router.push({name: 'questionnaire'})" class="bg-orange-600 hover:bg-orange-700 duration-200 text-white font-bold md:text-lg px-8 py-2 rounded-full">
                    Questionnaire <i class="fas fa-chevron-right ml-2"></i>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import ImageTracer from 'imagetracerjs'; // Importation si installé via npm
import axios from 'axios'

export default {
    data() {
        return {
            svgOutput: '', // Contient le SVG généré
            selectedPiece: null,

            pieces: [],

            piecesViewed: [],
        };
    },
    methods: {
        // Méthode pour gérer l'upload de fichier
        handleFileUpload(event) {
            const file = event.target.files[0];
            
            if (!file || !file.type.startsWith('image/')) {
                alert('Veuillez sélectionner une image valide.');
                return;
            }
            
            const reader = new FileReader();
            
            reader.onload = (e) => {
                const image = new Image();
                image.src = e.target.result;
                
                image.onload = () => {
                    // Prétraiter l'image pour isoler les murs et ignorer les textes
                    const filteredImageData = this.removeTextFromImage(image);
                    
                    // Options spécifiques pour les plans
                    const options = {
                        scale: 1,
                        pathomit: 3,        // Ignore les petits objets (textes inclus)
                        ltres: 0.1,         // Précision pour les lignes droites
                        qtres: 0.1,         // Précision pour les courbes
                        colorsampling: 0,   // Mode manuel
                        numberofcolors: 2,  // Binaire (noir et blanc)
                        strokewidth: 1.5,   // Lignes légèrement épaisses
                        linefilter: true,   // Priorise les lignes droites
                    };
                    
                    // Utiliser un Web Worker pour effectuer la conversion
                    const worker = new Worker(this.createWorkerBlob());
                    
                    worker.postMessage({ imageData: filteredImageData, options });
                    
                    worker.onmessage = (e) => {
                        this.svgOutput = e.data; // Affiche le SVG généré
                        worker.terminate();
                    };
                };
            };
            
            reader.readAsDataURL(file);
        },
        
        // Méthode pour supprimer les textes de l'image
        removeTextFromImage(image) {
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');
            
            canvas.width = image.width;
            canvas.height = image.height;
            
            // Dessiner l'image sur le canevas
            context.drawImage(image, 0, 0);
            const imageData = context.getImageData(0, 0, canvas.width, canvas.height);
            const data = imageData.data;
            
            // Appliquer un filtre pour supprimer les textes
            for (let i = 0; i < data.length; i += 4) {
                // Convertir en niveaux de gris
                const gray = 0.299 * data[i] + 0.587 * data[i + 1] + 0.114 * data[i + 2];
                
                // Suppression des petits objets en forme de texte (grains)
                if (gray > 200) {
                    // Suppression des objets clairs (potentiels textes)
                    data[i] = 255; // Rouge
                    data[i + 1] = 255; // Vert
                    data[i + 2] = 255; // Bleu
                }
            }
            
            context.putImageData(imageData, 0, 0);
            return context.getImageData(0, 0, canvas.width, canvas.height);
        },
        
        // Création d'un Web Worker à la volée
        createWorkerBlob() {
            const workerCode = `
        self.onmessage = function (e) {
          importScripts('https://cdn.jsdelivr.net/npm/imagetracerjs');
          const { imageData, options } = e.data;
          const svg = ImageTracer.imagedataToSVG(imageData, options);
          self.postMessage(svg);
        };
      `;
            
            const blob = new Blob([workerCode], { type: 'application/javascript' });
            return URL.createObjectURL(blob);
        },

        async getPieces() {
            let response = await axios.get('https://x8ki-letl-twmt.n7.xano.io/api:0NC1WJQ2/pieces')
            this.pieces = response.data
        },

        viewPiece(piece) {
            this.selectedPiece = piece
            this.$modal.show('modal-view-piece')
            let alreadyViewed = this.piecesViewed.find((item) => item == this.selectedPiece.id)
            if (!alreadyViewed) {
                this.piecesViewed.push(piece.id)
            }
        }
    },
    mounted () {
        this.getPieces()

        if (location.hostname !== "localhost" && location.hostname !== "127.0.0.1") {
            let token = localStorage.getItem('token')
            if (!token) {
                let makeid = (length) => {
                    let result = '';
                    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
                    const charactersLength = characters.length;
                    let counter = 0;
                    while (counter < length) {
                        result += characters.charAt(Math.floor(Math.random() * charactersLength));
                        counter += 1;
                    }
                    return result;
                }
                token = makeid(10)
                localStorage.setItem('token', token)
            }
            axios.post('https://x8ki-letl-twmt.n7.xano.io/api:0NC1WJQ2/views', {
                token: token,
                page: 'demo'
            })
        }
    },
};
</script>

<style>
h1 {
    font-family: Arial, sans-serif;
}

.loader {
  display: inline-block;
  position: relative;
}
.loader::after,
.loader::before {
  content: '';  
  box-sizing: border-box;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 8px solid #FFF;
  position: absolute;
  left: 0;
  top: 0;
  animation: animloader 2s linear infinite;
}
.loader::after {
  animation-delay: 1s;
}

@keyframes animloader {
  0% {
    transform: scale(0);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 0;
  }
}

.vm--overlay {
    background: rgba(0, 0, 0, 0.6) !important;
}
</style>
